import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  emmScreenuserIds: [],
  emmConfig:null
};
export const emmScreenuserSlice = createSlice({
  name: "emmConfig",
  initialState,
  reducers: {
    setEmmScreenuserIds: (state, action) => {
      state.emmScreenuserIds = action.payload;
    },
    setEmmLogoutScreenuserIds: (state, action) => {
      state.emmScreenuserIds = [];
    },
    setEmmConfig: (state, action) => {
      state.emmConfig = action.payload;
    },
    setEmmConfigLogout: (state, action) => {
      state.emmConfig = null;
    }
  },
});

export const { setEmmScreenuserIds, setEmmLogoutScreenuserIds, setEmmConfig, setEmmConfigLogout } =
  emmScreenuserSlice.actions;

export default emmScreenuserSlice.reducer;
